export default "__VITE_ASSET__BtGDN49k__"